// MyDrawer.tsx
import React, { useEffect } from 'react';
import { Grid, Box, Drawer, IconButton, Tabs, Tab, Typography } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import SearchableDropdown from "../components/SearchableDropdown";
import RefreshIcon from '@mui/icons-material/Refresh';

interface FilterDrawerProps {
  drawerOpen: boolean;
  handleDrawerClose: () => void;
  handleRefresh: () => void;
  selectedTab: number;
  handleChange: (event: React.ChangeEvent<{}>, newValue: number) => void;
  children: React.ReactNode;
}

interface LinkTabProps {
  label?: string;
  href?: string;
  value: number;
}

function LinkTab(props: LinkTabProps) {
  const { label, value, ...otherProps } = props;

  return (
    <Tab
      component="a"
      label={label}
      value={value}
      onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        event.preventDefault(); // Prevent the default anchor action
      }}
      {...otherProps}
      sx={{
        padding: '0px',
        flexGrow: 1,
        '&.Mui-selected': {
          color: 'grey', // Change the color of the selected tab to grey
        },
      }}
    />
  );
}


const FilterDrawer: React.FC<FilterDrawerProps> = ({ drawerOpen, handleDrawerClose, handleRefresh, selectedTab, handleChange, children }) => {

  const tabs: LinkTabProps[] = [
    { label: 'Sort & Filter', value: 1 },
  ];

  return (
    <Drawer
      variant="persistent"
      anchor="left"
      open={drawerOpen}
      onClose={handleDrawerClose}
      sx={{
        // overflowY: 'hidden',
        width: drawerOpen ? '400px' : '50px',
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerOpen ? '400px' : '0px',
          boxSizing: 'border-box',
          zIndex: 1201,
          position: "relative",
          transition: 'width 0.3s ease-out',
        },
      }}
    >
      <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ width: '100%', borderBottom: '.5px solid lightgrey', paddingBottom: '3.5px', paddingTop: '3.5px' }}>
        <IconButton aria-label="refresh" onClick={handleRefresh} sx={{marginLeft: 2}}>
          <RefreshIcon />
        </IconButton>
        <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
          <Typography variant="button" sx={{ paddingLeft: '20px', color: 'rgba(0, 0, 0, 0.6)' }}>
            SORT & FILTER
          </Typography>
        </Box>
        <IconButton onClick={handleDrawerClose} edge="end" sx={{ marginRight: '10px' }}>
          <ChevronLeftIcon />
        </IconButton>
      </Box>
      {children}
    </Drawer>
  );
}

export default FilterDrawer;
